// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2OJAy","footer":"ChangeClinic_footer__2vEDd"};